import React from 'react';
import { Routes, Route } from 'react-router-dom';

import AllServiceRecords from './admin/AllServiceRecords';
import EditServiceRecordPage from './admin/EditServiceRecordPage';
import ManageVehicles from './admin/ManageVehicles';
import DashboardPage from './admin/DashboardPage';
import ReportsPage from './admin/ReportsPage';
import CustomersPage from './admin/CustomersPage';
import CustomerDetailPage from './admin/CustomerDetailPage';
import PendingBookings from './admin/PendingBookings';
import PermissionRoute from '../components/PermissionRoute';

const AdminPage = () => {
    return (
        <div className="admin-page-wrapper">
        <Routes>
            <Route path="dashboard" element={<PermissionRoute permission="stats:view"><DashboardPage /></PermissionRoute>} />
            <Route path="reports" element={<PermissionRoute permission="stats:view"><ReportsPage /></PermissionRoute>} />
            <Route path="records" element={<PermissionRoute permission="records:view"><AllServiceRecords /></PermissionRoute>} />
            <Route path="records/:id/edit" element={<PermissionRoute permission="records:edit"><EditServiceRecordPage /></PermissionRoute>} />
            <Route path="vehicles" element={<PermissionRoute permission="vehicles:view"><ManageVehicles /></PermissionRoute>} />
            <Route path="customers" element={<PermissionRoute permission="customer:view"><CustomersPage /></PermissionRoute>} />
            <Route path="customers/:id" element={<PermissionRoute permission="customer:view"><CustomerDetailPage /></PermissionRoute>} />
            <Route path="pending-bookings" element={<PermissionRoute permission="records:edit"><PendingBookings /></PermissionRoute>} />
            <Route index element={<DashboardPage />} />
        </Routes>
        </div>
    );
};

export default AdminPage;
